import { Pipe, PipeTransform } from '@angular/core';
import { STAT_COLOR_CLASS } from '@shared/constants';

/**
 * Returns the color class string value based on the trend
 * @returns {string} The color class string value based on the trend, empty string if no match
 */

@Pipe({
    name: 'colorClass',
})
export class ColorClassPipe implements PipeTransform {
    transform(value: string): string {
        switch (value) {
            case 'up':
                return STAT_COLOR_CLASS.up;
            case 'down':
                return STAT_COLOR_CLASS.down;
            default:
                return '';
        }
    }
}
